<script setup>
import { computed } from 'vue';
import { EMOTIONS, emotionLabel, emotionDot } from '../utils/emotions.js';

const props = defineProps({
  data: { type: Array, default: () => [] },
});

const ordered = computed(() => {
  const map = new Map(props.data.map(d => [d.emotion, d]));
  return EMOTIONS.map(meta => ({
    ...meta,
    ...(map.get(meta.value) || { total: 0, positive: 0, negative: 0, neutral: 0 }),
  }));
});

const maxTotal = computed(() => Math.max(1, ...ordered.value.map(o => o.total)));
</script>

<template>
  <div class="rounded-xl border border-n-strong/40 bg-n-background p-4 shadow-sm">
    <div class="mb-3">
      <h3 class="text-sm font-semibold text-n-slate-12">Mapa de Emoções</h3>
      <p class="mt-0.5 text-[11px] text-n-slate-11">
        Detalhamento das 12 emoções identificadas no discurso.
      </p>
    </div>

    <div class="grid grid-cols-1 gap-1.5 md:grid-cols-2">
      <div
        v-for="e in ordered"
        :key="e.value"
        class="flex items-center gap-2 rounded-md border border-n-weak px-2 py-1.5"
      >
        <span :class="[e.icon, 'size-3.5 shrink-0 text-n-slate-12']" />
        <span class="w-24 shrink-0 truncate text-[11px] font-medium text-n-slate-12">
          {{ e.label }}
        </span>
        <div class="relative flex-1 overflow-hidden rounded-full bg-n-slate-3">
          <div
            class="h-1.5 rounded-full"
            :class="emotionDot(e.value)"
            :style="{ width: `${Math.round((e.total / maxTotal) * 100)}%` }"
          />
        </div>
        <span class="w-8 shrink-0 text-right text-[11px] font-semibold text-n-slate-12">
          {{ e.total }}
        </span>
      </div>
    </div>
  </div>
</template>
